<template>
  <top-nav>
    <li v-if="$can.view($store.getters.getAuthUser, 'create-performancebonds')">
      <router-link :to="{name: 'performance.create'}">
        Generate Performance Bond
      </router-link>
    </li>
    <li>
      <router-link :to="{ name: 'performance.index'}">
        Performance Bonds
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'refund-performance-cover')">
      <router-link :to="{ name: 'performance.matured'}">
        Matured Bonds
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'list-performance-templates')">
      <router-link :to="{name: 'performance.templates.index'}">
        Templates
      </router-link>
    </li>
    <template v-if="$can.view($store.getters.getAuthUser, 'list-performance-pricing')">
      <li>
        <router-link :to="{name: 'performance.pricing'}">
          Pricing
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'performance.pricing.group'}">
          Pricing Group
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'performance.counterparties.index'}">
          Counterparties
        </router-link>
      </li>
    </template>
  </top-nav>
</template>
<script>
import TopNav from "@/components/TopNav.vue";

export default {
  components: {
    TopNav
  },
}
</script>
